import Modal from "../modals/Modal";
import style from "styled-components";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch} from 'react-redux';
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  ButtonsContainerTuPay,
  AmountButton
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../features/user/userSlice";
import COINSPAID from '../../assets/images/ALPHAPO.svg';
import Rcoinspaid from '../../assets/images/RECARGA CON ALPHAPO-01.svg';
import {setMinimo} from '../../features/modals/modalsSlice';

const FormCoinspaid = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
}) => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const moneda = useSelector(selectCurrency);
  const [Cryptos, setCryptos] = useState([]);
  const validCurrencies = ['$','ARS', 'Bs.S', 'VES', 'DOP', 'MXN', 'COP', 'CLP', 'BOB', 'PEN'];
  const [monedaAux, setmonedaAux] = useState(validCurrencies.includes(moneda) ? 'USD' : moneda);
  const [currencyData, setCurrencyData] = useState({});
  const [responseData, setResponseData] = useState([]);
  const [minimumAmount, setminimumAmount] = useState('');

  useEffect(() => {
    const fetchCryptos = async () => {
      const url = `https://app.masterbets365.com/API/CoinsPaid/index.php/Api/getCryptocurrencies/${monedaAux}`;
      const response = await axios.get(url);
      if (response.data.code === 200) {
        const CryptosHabilitadas = response.data.cryptocurrencies;
        const responseCryptos = response.data.response_data.data;

        setCryptos(CryptosHabilitadas);
        setResponseData(responseCryptos);

        // Mapea la información de las criptomonedas
        const cryptoData = CryptosHabilitadas.reduce((acc, crypto) => {
          acc[crypto.cryptocurrency] = crypto;
          return acc;
        }, {});

        setCurrencyData(cryptoData);
      }
    };
    fetchCryptos();
  }, []); // Se ejecutará cuando cambie monedaAux

  const handleCryptoChange = (e) => {
    const { value } = e.target;

    if (currencyData.hasOwnProperty(value)) {
      const selectedCurrencyData = currencyData[value];

      const correspondingResponse = responseData.find(item => item.currency === value);

      if (correspondingResponse && selectedCurrencyData.minimum_amount !== parseFloat(correspondingResponse.minimum_amount)) {
        dispatch(setMinimo(parseFloat(correspondingResponse.minimum_amount)));
      } else {
        dispatch(setMinimo(selectedCurrencyData.minimum_amount));
      }
    }

    handleChange(e);
  };

  return (
    <Form className={'tupay'} style={{minHeight: '40vh'}}>
      <InputContainer>
        <label>{t("deposit.criptomoneda")}:</label>
        <select value={form.cryptocurrency} onChange={handleCryptoChange} name='cryptocurrency'>
          <option disabled value=''>{t("deposit.selectcripto")}</option>
          {Cryptos.map((crypto) => (
            <option key={crypto.cryptocurrency} value={crypto.cryptocurrency}>
              {`${crypto.cryptocurrency} - ${crypto.network}`}
            </option>
          ))}
        </select>
      </InputContainer>
      <img src={Rcoinspaid} alt='coinspaid' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={COINSPAID} alt='Pasarelas ALPHAPO' className={'tupa2'} style={{height: '40px', width:'100%', marginTop: '2%', marginLeft: '0.2%'}}/>
      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
        <Button
          primary={true}
          disabled={loading || form.cryptocurrency === ''}
          onClick={handleSubmit}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-next")}
        </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormCoinspaid;
